import { Navigate, useLocation } from 'react-router';

import { isBackOffice } from '../layout/navigation';
import { InboxPage } from '../pages/InboxPage';
import { useFieldOnly, useProject } from '../projects/context';

// Moved: frühere Einzelseiten leiten auf den Reiter des neuen Arbeitsbereichs weiter; vorhandene Parameter
// (z. B. ?due=overdue aus Benachrichtigungen) bleiben erhalten.
export function Moved({ to, view }: { to: string; view: string }) {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  params.set('ansicht', view);
  return <Navigate to={`../${to}?${params}`} replace />;
}

// Posteingang nur für das Büro (Support, Leitung); alle anderen landen auf ihrer eigenen Sicht.
export function InboxRoute() {
  const { can } = useProject();
  const fieldOnly = useFieldOnly();
  if (!isBackOffice({ can, fieldOnly })) return <Navigate to=".." replace />;
  return <InboxPage />;
}

// Wiedervorlagen: im Büro als Reiter des Posteingangs, für Telefonisten als Ansicht der Akquise.
export function FollowUpsRoute() {
  const { can } = useProject();
  const fieldOnly = useFieldOnly();
  return isBackOffice({ can, fieldOnly }) ? <Moved to="posteingang" view="wiedervorlagen" /> : <Moved to="akquise" view="wiedervorlagen" />;
}
